module.exports = __webpack_public_path__ + "media/images/front/icon_down_green-4a09afd7c84ed4a7a8d23978ec98c93d.png";